import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ReactNode } from 'react';

import { useAuth, useClanInvitation } from '../hooks';
// Pages
import {
  Clan,
  ClanArenaRedirect,
  CompleteProfile,
  Home,
  League,
  MyCollections,
  Profile,
  RecoverPassword,
  SignIn,
  SignUp,
} from '../pages';
import { ROUTES } from '../routes';

type ProtectedRouteProps = {
  children: ReactNode;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return null; // o tu <Spin />
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
};

const Router = () => {
  useClanInvitation();

  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path={ROUTES.SIGNIN} element={<SignIn />} />
        <Route path={ROUTES.SIGNUP} element={<SignUp />} />
        <Route path={ROUTES.RECOVER_PASSWORD} element={<RecoverPassword />} />

        {/* Private routes */}
        <Route
          path={ROUTES.HOME}
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.COMPLETE_PROFILE}
          element={
            <ProtectedRoute>
              <CompleteProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PROFILE}
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        {/* 👇 /league */}
        <Route
          path={ROUTES.LEAGUE}
          element={<Navigate to={ROUTES.HOME} replace />}
        />
        {/* 👇 /league/:path */}
        <Route
          path={`${ROUTES.LEAGUE}/:path/*`}
          element={
            <ProtectedRoute>
              <League />
            </ProtectedRoute>
          }
        />
        {/* 👇 /league/clan-arena/:path */}
        <Route
          path={`${ROUTES.LEAGUE}${ROUTES.CLAN_ARENA}/:path`}
          element={
            <ProtectedRoute>
              <ClanArenaRedirect />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.MY_COLLECTIONS}
          element={
            <ProtectedRoute>
              <MyCollections />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.CLAN}
          element={
            <ProtectedRoute>
              <Clan />
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
